import { render } from "./AppSecurity.vue?vue&type=template&id=2a8123aa&ts=true"
import script from "./AppSecurity.vue?vue&type=script&lang=ts"
export * from "./AppSecurity.vue?vue&type=script&lang=ts"

import "./AppSecurity.vue?vue&type=style&index=0&id=2a8123aa&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__